import { api_url } from "../configiration/config";
import { axiosClone } from "./../axiosClone";

// get about settings
export async function getAboutSettings(){
    return await axiosClone.get(`${api_url}/headers/about-us`);
}
// get benefits
export async function getBenefits(){
    return await axiosClone.get(`${api_url}/benefits`);
}
// get testmonials
export async function getTestmonials(){
    return await axiosClone.get(`${api_url}/testimonies`);
}